import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currency";
import { ProtectedRoute, RoleHome } from "@/lib/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ProfilePage from "@/pages/Profile";

import GlobalAdminDashboard from "@/pages/admin/GlobalDashboard";
import CompaniesPage from "@/pages/admin/Companies";
import PlansPage from "@/pages/admin/Plans";
import PaymentsPage from "@/pages/admin/Payments";
import PlatformSettings from "@/pages/admin/PlatformSettings";

import CompanyDashboard from "@/pages/company/CompanyDashboard";
import CustomersPage from "@/pages/company/Customers";
import SavingsPage from "@/pages/company/Savings";
import LoansPage from "@/pages/company/Loans";
import StaffPage from "@/pages/company/Staff";
import ReportsPage from "@/pages/company/Reports";
import BillingPage from "@/pages/company/Billing";
import AccountingPage from "@/pages/company/Accounting";
import FinancePage from "@/pages/company/Finance";

import CustomerPortal from "@/pages/customer/Portal";
import Proposal from "@/pages/Proposal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<ProtectedRoute><RoleHome /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><AppLayout><ProfilePage /></AppLayout></ProtectedRoute>} />

            {/* Global admin */}
            <Route path="/admin" element={<ProtectedRoute roles={["GLOBAL_ADMIN"]}><AppLayout><GlobalAdminDashboard /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/companies" element={<ProtectedRoute roles={["GLOBAL_ADMIN"]}><AppLayout><CompaniesPage /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/plans" element={<ProtectedRoute roles={["GLOBAL_ADMIN"]}><AppLayout><PlansPage /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/payments" element={<ProtectedRoute roles={["GLOBAL_ADMIN"]}><AppLayout><PaymentsPage /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute roles={["GLOBAL_ADMIN"]}><AppLayout><ReportsPage /></AppLayout></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute roles={["GLOBAL_ADMIN"]}><AppLayout><PlatformSettings /></AppLayout></ProtectedRoute>} />

            {/* Company / Staff */}
            <Route path="/dashboard" element={<ProtectedRoute roles={["COMPANY_ADMIN", "USER"]}><AppLayout><CompanyDashboard /></AppLayout></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute roles={["COMPANY_ADMIN", "USER"]}><AppLayout><CustomersPage /></AppLayout></ProtectedRoute>} />
            <Route path="/savings" element={<ProtectedRoute roles={["COMPANY_ADMIN", "USER"]}><AppLayout><SavingsPage /></AppLayout></ProtectedRoute>} />
            <Route path="/loans" element={<ProtectedRoute roles={["COMPANY_ADMIN", "USER"]}><AppLayout><LoansPage /></AppLayout></ProtectedRoute>} />
            <Route path="/staff" element={<ProtectedRoute roles={["COMPANY_ADMIN"]}><AppLayout><StaffPage /></AppLayout></ProtectedRoute>} />
            <Route path="/accounting" element={<ProtectedRoute roles={["COMPANY_ADMIN", "USER"]}><AppLayout><AccountingPage /></AppLayout></ProtectedRoute>} />
            <Route path="/finance" element={<ProtectedRoute roles={["COMPANY_ADMIN", "USER"]}><AppLayout><FinancePage /></AppLayout></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute roles={["COMPANY_ADMIN"]}><AppLayout><ReportsPage /></AppLayout></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute roles={["COMPANY_ADMIN"]}><AppLayout><BillingPage /></AppLayout></ProtectedRoute>} />

            {/* Customer */}
            <Route path="/portal" element={<ProtectedRoute roles={["CUSTOMER"]}><AppLayout><CustomerPortal /></AppLayout></ProtectedRoute>} />
            <Route path="/portal/loans" element={<ProtectedRoute roles={["CUSTOMER"]}><AppLayout><CustomerPortal /></AppLayout></ProtectedRoute>} />
            <Route path="/portal/savings" element={<ProtectedRoute roles={["CUSTOMER"]}><AppLayout><CustomerPortal /></AppLayout></ProtectedRoute>} />

            {/* Public proposal for preview/run */}
            <Route path="/proposal" element={<Proposal />} />

            <Route path="*" element={<ProtectedRoute><RoleHome /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
